import _ from 'lodash';
import React from 'react';
import {combineReducers} from 'redux-immutable';
import treeReducer from '../tree/reducer';
import Tree from '../tree';


export const initialState = {};

export const reducer = combineReducers({
    parentTree: treeReducer,
    childTree: treeReducer,
});

export const component = props => <div>
    <Tree store={props.store.get('parentTree')} {...props.parentTree}/>
    <br/>
    {props.requiredParent && props.store.getIn(['parentTree', 'selected']).size === 0
        ? null
        : <Tree
            store={props.store.get('childTree')}
            {...props.childTree}
            requiredFields={[props.parentField]}
            filter={_.merge(
                props.childTree.filters,
                {[props.parentField]: props.store.getIn(['parentTree', 'selected']).keySeq().join(',')},
            )}
        />
    }
</div>;
